import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ApiCallService } from 'src/app/core/services/api-call-service';
import { SnackbarCollection } from 'src/app/core/services/snackbar.service';
import { BadgeCreateComponent } from '../badge-create/badge-create.component';
import { ConfirmationDialogBoxComponent } from "src/app/shared/components/dialog-box";
import { TranslateDynamicText } from 'src/app/shared/pipes/dynamic-translation.pipe';
import { getdateformatService } from 'src/app/core/services/get-date-format.service';
import { Globals } from 'src/app/core/services/global.service';
// import { BadgePreviewComponent } from 'src/app/shared/components/badge-preview/badge-preview.component';

@Component({
  selector: 'app-badge-listing',
  templateUrl: './badge-listing.component.html',
  styleUrls: ['./badge-listing.component.css']
})
export class BadgeListingComponent implements OnInit {

  constructor(
    private dialog: MatDialog, 
    private _apicall:ApiCallService,
    private _snackBar:SnackbarCollection, 
    private _i18nDynamicTranslate:TranslateDynamicText,
    private date_format: getdateformatService,
    private global: Globals) { }

  getDateFormat(type?){
    return this.date_format.getDateFormat(type);
  }

  ngOnInit(): void {
    this.loadData();
  }

  openCreateDialog(mode?,id?) {
    const dialogRef = this.dialog.open(BadgeCreateComponent, { 
      width: '80vw',
      height: '90vh',
      data: id?{
        id:id,
        mode:mode,
      }:{
        mode:'create',
      },
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.loadData();
      }
    });
  }


  badgeList = [];
  isDataLoading = false;
  loadData() {
    this.isDataLoading = true;
    this._apicall.getBadgesByMerchantId().subscribe(
      response => {
          this.originalBadgeList = response["body"];
          this.resetSearch();
          this.isDataLoading = false;
      },
      error => {
        this.isDataLoading = false;
        this._snackBar.openSnackBar(error.error, 4000);
      }
    );
  }

  deleteBadge(id) {
    let badgeName = this.badgeList.find(listObject=>listObject.id == id).name;
    const dialogref = this.dialog.open(
      ConfirmationDialogBoxComponent,
      {
        panelClass: "no-padding-dialog-popup",
        width: "280px",
        data: {
          subject: `DELETE ${badgeName}`,
          message: `Are you sure you want to delete ${badgeName}? All data filled for this will be lost once deleted.`,
          cancelButtonText: this._i18nDynamicTranslate.transform("Cancel", ['POS_PAGE']),
          successButtonText: this._i18nDynamicTranslate.transform("Delete", ['POS_PAGE']),
        }
      }
    );
    dialogref.afterClosed().subscribe((result) => {
      if(result) {
        this._snackBar.openSnackBar("Deleting your badge...",0);
        this._apicall.deleteBadge(id).subscribe(
          (response)=>{
            this._snackBar.dismiss();
            this._snackBar.openSnackBar("Successfully Deleted", 2000);
            this.originalBadgeList = this.originalBadgeList.filter(listObject=>listObject.id != id);
            this.resetSearch();
          },
          (error)=>{
            this._snackBar.dismiss();
            const dialogref = this.dialog.open(
              ConfirmationDialogBoxComponent,
              {
                panelClass: "no-padding-dialog-popup",
                width: "280px",
                data: {
                  subject: `Cannot delete this badge`,
                  message: error.error,
                  successButtonText: this._i18nDynamicTranslate.transform("Ok", ['POS_PAGE']),
                }
              }
            );
          }
        );
      }
    });
  }

  // previewBadge(badgeId) {
  //   const dialogref = this.dialog.open(
  //     BadgePreviewComponent,
  //     {
  //       panelClass: "no-padding-dialog-popup",
  //       width: "280px",
  //       data: {
  //         "badgeId" : badgeId
  //       }
  //     }
  //   );
  // }

  listSearch = '';
  originalBadgeList = [];
  onKeySearch() {
    if(!this.listSearch) {
      this.badgeList = this.originalBadgeList;
    } else {
      this.badgeList = this.originalBadgeList.filter(badge => badge.name.toLowerCase().includes(this.listSearch.toLowerCase()));
    }
  }

  resetSearch() {
    this.badgeList = this.originalBadgeList;
    this.listSearch = '';
  }

  getDateInTimeZone(timestamp, format: 'time' | 'date'): string {
    return this.global.getDateInTimeZone2(timestamp, format);
  }


}
